import { refreshRedsysOnError } from "./tech.newEnrollment";

//Redys payments
var counterSecondsThreeDSMethod = 0;
var counter;
var counterframesLoaded = 0;
var isThreeDSMethodExecuted = false;
var T = {};
var E = {};
var numPedido;

const THIRD_STEP = document.getElementById('enrollment-third-step');

window.addEventListener("message", function receiveMessage(event) {
    processEventRedsys(event);
});

export function main() {

    T = JSON.parse(document.getElementById('translations').value.replaceAll("##", "'"));
    E = JSON.parse(document.getElementById('redsysErrorMsg').value.replaceAll("##", "'"));


    counterframesLoaded = 0;
    isThreeDSMethodExecuted = false;
    console.log('Se ejecuta el tech.redsys');

    setupRedsysForm();
    //sendHotJarEvent('preorder', ['order-numPedido', 'codigo-pedido-redsys', 'redsys-amount', 'codigo-moneda-redsys', 'codigo-comercio-redsys']);

}

export function setupRedsysForm() {

    $("#is-redsys-platform-form").ready(() => {
        let redsysCresVal = $('redsys-cres').val();
        let rSysParEsVal = $('redsys-PARes').val();
        let userEmail = document.getElementById('user-email') ? document.getElementById('user-email').value : null;
        if ((!redsysCresVal || redsysCresVal.length === 0) && (!rSysParEsVal || rSysParEsVal.length === 0)) {
            if (userEmail !== null && userEmail === document.getElementById('settings-email').value && document.getElementById('settings-test-enabled').value === "true") {
                tech.core.loadScripts([REDSYS_URL_TEST], () => {
                    loadInputs();
                    onLoadFramesOfInputs();
                });
            } else {
                tech.core.loadScripts([REDSYS_URL], () => {
                    loadInputs();
                    onLoadFramesOfInputs();
                });
            }
        }

        document.getElementById('threeDSMethod-submit').addEventListener("click", () => {
            starCounterSeconds();
        });

        document.getElementById('threeDSMethod-iframe').addEventListener('load', () => {
            if (!isThreeDSMethodExecuted) {
                let threeDSCompInd = 'N';
                if (counterSecondsThreeDSMethod <= 10) {
                    clearInterval(counter);
                    threeDSCompInd = 'Y';
                }
                processThreeDSMethod(threeDSCompInd);
            }
        });
    });
}

export function loadInputs() {
    let redsys_terminal = document.getElementById('codigo-terminal-redsys').value || "001";
    let redsys_fuc = document.getElementById('codigo-comercio-redsys').value || "126934637";
    let merchantOrder = document.getElementById('codigo-pedido-redsys').value;

    let styleButton = "background-color: #05b1ca;height: -webkit-fit-content;text-transform: uppercase;height: -moz-fit-content;padding: 0.58rem 2.6rem;height: fit-content;" +
        "font-size: .65rem;font-weight: 500;color: #fff;margin: 0 auto;border-radius: 0.25rem;word-wrap: break-word;white-space: normal;border: 0;" +
        "box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%);line-height: 1.5;text-decoration: none;text-align: center;vertical-align: middle; display: flex;";
    let styleInputs = 'padding: .375rem 10px;border: 1px solid #ced4da;width: calc(100% - 20px);border-radius: .25rem;font-size: 1rem;font-weight: 400;line-height: 1.5';
    let textPayButtonVal = document.getElementById('text-pay-button').value;

    getPayButton('redsys-pay-button', styleButton, (textPayButtonVal || '').toUpperCase(), redsys_fuc, redsys_terminal, merchantOrder);
    getCardInput('redsys-payment-card-number', styleInputs);
    getExpirationYearInput('redsys-card-expiration-year', styleInputs);
    getExpirationMonthInput('redsys-card-expiration-month', styleInputs);
    getCVVInput('redsys-card-cvv', styleInputs);
}

export function onLoadFramesOfInputs() {
    document.getElementById('' + document.getElementById('redsys-pay-button').querySelector("iframe").getAttribute("id") + '').addEventListener('load', () => {
        setMerchantDomain();
        inputLoaded();
    });
    document.getElementById('' + document.getElementById('redsys-payment-card-number').querySelector("iframe").getAttribute("id") + '').addEventListener('load', () => inputLoaded());
    document.getElementById('' + document.getElementById('redsys-card-expiration-month').querySelector("iframe").getAttribute("id") + '').addEventListener('load', () => inputLoaded());
    document.getElementById('' + document.getElementById('redsys-card-expiration-year').querySelector("iframe").getAttribute("id") + '').addEventListener('load', () => inputLoaded());
    document.getElementById('' + document.getElementById('redsys-card-cvv').querySelector("iframe").getAttribute("id") + '').addEventListener('load', () => inputLoaded());
}

export function inputLoaded() {
    counterframesLoaded++;
    if (counterframesLoaded === 5) {
        setTimeout(() => {
        }, 1500);
    }
}

/*export function sendHotJarEvent(eventName,targetElements) {
    console.log(eventName, targetElements, hj)
    if (hj) {
        var msg = eventName + ':';
        if (targetElements) {
            for (var i = 0; i < targetElements.length; i++) {
                var inp = document.getElementById(targetElements[i])
                if (inp.value && inp.value != "") {
                    msg += ' ' + targetElements[i] + '=' + inp.value;
                }
            }
            hj('event', msg);
        }
    }
}*/

export function saveErrorRedsys(idOperation) {
    $.ajax({
        type: 'post',
        url: tech.core.getInternationalUrl('/PaymentToken/SaveErrorRedsys'),
        data: { paymentInformationDto: getPaymentRedsysData(idOperation, getInfoBrowser()) },
        dataType: 'json'
    }).done();
}

export function processEventRedsys(event) {
    console.log("processEventRedsys");
    if ($("#codigo-pedido-redsys").length > 0) {
        storeIdOper(event, "redsys-id-operation", "redsys-error-code", "validationTokenRedsys");
        //sendHotJarEvent('redsys event', ['order-numPedido', 'codigo-pedido-redsys', 'redsys-id-operation', 'redsys-error-code']);
    }

    if (event.data) {
        if (event.data.error) {
            $("#redsys-card-error").text(getErrorMessageRedsysInsite(event.data.error));
        } else if (event.data.idOper) {
            if (event.data.idOper !== "-1") {
                console.log("muestra spinner");
                tech.formFunctions.toggleSpinnerBlock('enrollment-spinner', 'enrollment-third-step', '', T.processingRequest, true);
                tech.formFunctions.scrollToElement(THIRD_STEP);
                processPaymentByRedsysInsite('processPayment', event.data.idOper, getInfoBrowser());
            } else {
                saveErrorRedsys(event.data.idOper);
                showPaymentInfoModal(T.thereWasAnErrorTryLater);
                console.log("oculta spinner");
                tech.formFunctions.toggleSpinnerBlock('enrollment-spinner', 'enrollment-third-step', '', '', false);
                refreshRedsysOnError();
            }
        }
        if (event.data.action === "close") {
            $('#redsys-enrollment-modal').modal('hide');
        }
        if (event.data.cres) {
            processChallenge(event.data);
        }
        if (event.data.PARes && event.data.MD) {
            processChallenge(event.data);
        }
    }
}

export function validationTokenRedsys() {
    return true;
}

export function getErrorMessageRedsysInsite(error) {

    var domErr = document.getElementById('Redsys_' + error);
    if (domErr) {
        return domErr.value;
    }

    switch (error) {
        case 'msg1': return E.msg1;
        case 'msg2': return E.msg2;
        case 'msg3': return E.msg3;
        case 'msg4': return E.msg4;
        case 'msg5': return E.msg5;
        case 'msg6': return E.msg6;
        case 'msg7': return E.msg7;
        case 'msg8': return E.msg8;
        case 'msg9': return E.msg9;
        case 'msg10': return E.msg10;
        case 'msg11': return E.msg11;
        case 'msg12': return E.msg12;
        case 'msg13': return E.msg13;
        case 'msg14': return E.msg14;
        case 'msg15': return E.msg15;
        case 'msg16': return E.msg16;
        case 'msg17': return E.msg17;
    }
}

export function getInfoBrowser() {
    let infoBrowser = {
        browserUserAgent: navigator.userAgent,
        browserJavaEnabled: navigator.javaEnabled(),
        browserLanguage: navigator.language,
        browserColorDepth: screen.colorDepth,
        browserScreenHeight: screen.height,
        browserScreenWidth: screen.width,
        browserAcceptHeader: document.getElementById('redsys-browser-accept-header').value,
        browserJavascriptEnabled: true,
        browserTZ: new Date().getTimezoneOffset()
    }
    return infoBrowser;
}

export function getPaymentRedsysData(idOperation, redsys3DS) {
    let processPaymentRedsysData = {
        numPedido: document.getElementById("order-numPedido").value,
        codigoPedidoRedsys: document.getElementById("codigo-pedido-redsys").value,
        amount: document.getElementById("redsys-amount").value,
        idOperation: idOperation,
        token: document.getElementById("token").value,
        policiesAccepted: 'true',
        conditionsAccepted: 'true',
        redsys3DS: redsys3DS,
        clientData: document.getElementById("order-client-data").value,
        idPago: document.getElementById("order-idPago").value,
        tpvData: {
            merchantCode: document.getElementById('codigo-comercio-redsys').value,
            merchantTerminal: document.getElementById('codigo-terminal-redsys').value,
            merchantCurrency: document.getElementById('codigo-moneda-redsys').value
        },
        isEnrollment: true
    }
    return processPaymentRedsysData;
}

export function processPaymentByRedsysInsite(typeProcess, idOperation, redsys3DS) {
    console.log("processPaymentByRedsysInsite");
    $.ajax({
        type: 'post',
        url: tech.core.getInternationalUrl('/PaymentToken/ProcessPaymentRedsys'),
        data: {
            typeProcess: typeProcess,
            paymentInformationDto: getPaymentRedsysData(idOperation, redsys3DS)
        },
        dataType: 'json'
    }).done(response => {
        console.log('processPaymentByRedsysInsite response ajax',response);
        if (response.url != null) {
            var finishDateDom = document.getElementById('finishDate');
            if (finishDateDom) {
                response.url.courseDateFinish = finishDateDom.value;
            }
            redsysConfirmationPage(response.url);
        } else if (response.errorMessage != null) {
            showPaymentInfoModal(response.errorMessage);            
            console.log("oculta spinner");
            //SI EL PAGO FALLA HAY QUE REINICIAR EL FORMULARIO
            tech.formFunctions.toggleSpinnerBlock('enrollment-spinner', 'enrollment-third-step', '', '', false);
            tech.newEnrollment.refreshRedsysOnError();
        } else if (response.redsys3DS != null) {
            if (response.redsys3DS.threeDSMethodURL != null) {
                threeDSMethod(response.redsys3DS);
            } else if (response.redsys3DS.threeDSInfo === "ChallengeRequest") {
                processChallengeVersion(response.redsys3DS);
            }
        }
    });
}

export function redsysConfirmationPage(enrollmentSucessModel) {
    console.log("redsysConfirmationPage");
    $.ajax({
        type: 'POST',
        url: tech.core.getInternationalUrl('/Course/RedsysConfirmation'),
        data: JSON.stringify(enrollmentSucessModel),
        contentType: 'application/json',
        dataType: 'html',
        success: successFunc,
        error: errorFunc
    });

    function successFunc(data, status) {
        console.log("oculta spinner");

        tech.formFunctions.toggleSpinnerBlock('enrollment-spinner', 'enrollment-third-step', '', '', false);
        tech.formFunctions.scrollToElement(THIRD_STEP);
        //hideSpinner('enrollment-spinner', 'redsys-group', true);
        $('#enrollment-third-step').html("");
        $('#enrollment-third-step').append(data);

        $(document).ready(function () {
            numPedido = document.getElementById('orderNumber').value;
        });

        if (typeof callback !== "undefined") {
            callback();
        }
    }

    function errorFunc(jQXHR, textStatus, errorThrown) {
        console.log("An error occurred while trying to contact the server: " + jQXHR.status + " " + textStatus + " " + errorThrown);
        console.log("oculta spinner");
        tech.formFunctions.toggleSpinnerBlock('enrollment-spinner', 'enrollment-third-step', '', '', false);
        //hideSpinner('enrollment-spinner', 'redsys-group', true);
    }
}

export function threeDSMethod(redsys3DS) {
    console.log("threeDSMethod");
    document.getElementById('threeDSMethod-form').setAttribute('action', redsys3DS?.threeDSMethodURL);
    document.getElementById('threeDSMethodData').value = redsys3DS?.threeDSMethodData;
    console.log("ThreeDSMethod", redsys3DS?.threeDSMethodURL);
    //showRedsysModal();
    $('#threeDSMethod-submit').trigger('click');
    starCounterSeconds();
}

export function starCounterSeconds() {
    counter = setInterval(() => {
        if (counterSecondsThreeDSMethod >= 10) {
            clearInterval(counter);
        }
        ++counterSecondsThreeDSMethod;
    }, 1000);
}

export function processThreeDSMethod(threeDSCompInd) {
    console.log("processThreeDSMethod");
    let redsys3DS = getInfoBrowser();
    redsys3DS.threeDSCompInd = threeDSCompInd;
    isThreeDSMethodExecuted = true;
    processPaymentByRedsysInsite('threeDSMethod', $("#redsys-id-operation").val(), getInfoBrowser());
}

export function processChallenge(redsysResponse) {
    console.log("processChallenge");
    tech.formFunctions.toggleSpinnerBlock('enrollment-spinner', 'enrollment-third-step', '', T.loading, true);
    let redsys3DS = getInfoBrowser();
    if (redsysResponse.cres) {
        redsys3DS.cres = redsysResponse.cres;
    }
    if (redsysResponse.PARes && redsysResponse.MD) {
        redsys3DS.PARes = redsysResponse.PARes;
        redsys3DS.MD = redsysResponse.MD;
    }
    processPaymentByRedsysInsite('challenge', $("#redsys-id-operation").val(), redsys3DS);
}

export function processChallengeVersion(redsys3DS) {
    console.log("processChallengeVersion");
    console.log("muestra spinner");
    tech.formFunctions.toggleSpinnerBlock('enrollment-spinner', 'enrollment-third-step', '', T.redirectingBank, true);
    setTimeout(() => {
        if (redsys3DS.protocolVersion.startsWith("1.")) {
            challengeV1(redsys3DS.paReq, redsys3DS.md, redsys3DS.termUrl, redsys3DS.acsUrl);
        } else {
            challengeV2(redsys3DS.creq, redsys3DS.acsUrl);
        }
        console.log("oculta spinner");
        tech.formFunctions.toggleSpinnerBlock('enrollment-spinner', 'enrollment-third-step', '', '', false);
    }, 3500);
}

export function challengeV1(paReq, md, termUrl, acsURL) {
    console.log("Challenge V1", paReq, md, termUrl, acsURL);
    document.getElementById('challenge-redsys-form-v1').setAttribute('action', acsURL);
    document.getElementById('redsys-PaReq-form').value = paReq;
    document.getElementById('redsys-md-form').value = md;
    document.getElementById('redsys-termurl-form').value = termUrl;
    showRedsysModal();
    $('#challenge-redsys-submit-v1').trigger('click');
}

export function challengeV2(creq, acsURL) {
    console.log("Challenge V2", creq, acsURL);
    document.getElementById('challenge-redsys-form-v2').setAttribute('action', acsURL);
    document.getElementById('challenge-redsys-creq').value = creq;
    showRedsysModal();
    $('#challenge-redsys-submit-v2').trigger('click');
}

export function showPaymentInfoModal(errorMessage) {
    $('#payment-info-modal').modal({
        keyboard: false,
        backdrop: 'static'
    });
    $('#message-payment-modal').html('<p>' + errorMessage + '</p>');
    $('#payment-info-modal').modal('show');
}


export function showRedsysModal() {
    $('#redsys-enrollment-modal').modal({
        keyboard: false,
        backdrop: 'static'
    });
    $('#redsys-enrollment-modal').modal('show');
}

export function showSpinner(message, spinnerWrapper, wrapperToHide, targetBackDrop) {
    document.getElementById(wrapperToHide).style.display = 'none';
    var spinnerMessageWrapper = document.getElementById('payment-spinner-message');
    if (spinnerMessageWrapper) {
        spinnerMessageWrapper.textContent = message;
    }

    if (document.getElementById(spinnerWrapper).children.length === 0) {
        document.getElementById(spinnerWrapper).innerHTML='<div class="payment-spinner-wrapper"><div class="spinner-border m-5" role="status"><span class="sr-only">' + T.loading + '</span></div><p id="payment-spinner-message">' + T.loading + '</p></div>';
    }
    

    document.getElementById(spinnerWrapper).style.display = 'block';

    var spinner = document.getElementById(spinnerWrapper);
    spinner && scrollToElement(spinner);
}

export function hideSpinner(spinnerWrapper, wrapperToShow, targetBackDrop) {
    var spinnerWrapperDOM = document.getElementById(spinnerWrapper);
    if (spinnerWrapperDOM) {
        spinnerWrapperDOM.style.display = 'none';
    }

    if (targetBackDrop) {
        var backDropDOM = document.querySelector('.backDrop');
        if (backDropDOM) {
            backDropDOM.remove();
        }
    }

    var spinnerMessageDOM = document.getElementById('payment-spinner-message');
    if (spinnerMessageDOM) {
        spinnerMessageDOM.textContent = '';
    }

    var wrapperToShowDOM = document.getElementById(wrapperToShow);
    if (wrapperToShowDOM) {
        wrapperToShowDOM.style.display = 'block';
    }
}
function scrollToElement(element) {
    var elementRect = element.getBoundingClientRect();
    const absoluteElementTop = elementRect.top + window.pageYOffset;
    const middle = absoluteElementTop - (window.innerHeight / 2);

    window.scroll(0, middle);
}



